export default __webpack_public_path__ + "static/media/Artboard 41.bececd68.png";